
import Mainroutes from './Routes';
import "./index.css";
import "./style.css";
import "bootstrap/dist/css/bootstrap.min.css";
import { ToastContainer } from "react-toastify";
import { TokenContext } from "./context/TokenContext";

function App() {
  return (
    <TokenContext>
      <Mainroutes />
      <ToastContainer position="bottom-left" />
    </TokenContext>
  );
}

export default App;
